import React from "react"
import ToolBoxList from "../components/ToolBoxList"
import items from "../content/toolbox-list"
import ToolBoxPopOver from "../components/ToolBoxPopOver"
import FaUser from "react-icons/lib/fa/user"
import { OutboundLink as Out } from 'gatsby-plugin-google-analytics'


export default class extends React.Component {

  state = {
    items: items,
    activatedItemId: null,
    popOverPosition: null,
    popOver: {
      isActive: false,
      topPx: "auto",
      bottomPX: "auto",
      leftPx: "auto",
      rightPx: "auto",
      description: "",
      comment: ""
    },
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.windowResizeHandler, false)
      window.addEventListener("click", this.windowClickHandler, false)
      window.addEventListener("keydown", this.windowKeyDownHandler, false)
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.windowResizeHandler, false)
      window.removeEventListener("click", this.windowClickHandler, false)
      window.removeEventListener("keydown", this.windowKeyDownHandler, false)
    }
  }

  deactivatePopOver = () => {
    this.setState({
      popOver: {
        isActive: false
      },
      activatedItemId: null,
      popOverPosition: null
    })
  }

  windowKeyDownHandler = e => this.state.activatedItemId && e.which == 27 && this.deactivatePopOver()

  windowResizeHandler = () => this.state.activatedItemId && this.deactivatePopOver()

  windowClickHandler = e => (
    !(e.target.nodeName === "A" || e.target.nodeName === "BUTTON") 
    && this.state.activatedItemId 
    && this.deactivatePopOver()
  )

  toolClickHandler = (e, id) => {
    const currentItem = this.state.items.find(item => item.id === id)

    const popWidth = 200
    const popHeight = 100
    const body = document.querySelector("body")

    const spaceUnder = body.offsetHeight - e.target.offsetTop - e.target.offsetHeight
    const spaceOnRight = body.offsetWidth - e.target.offsetLeft - e.target.offsetWidth

    const verticalPositionUnder = spaceUnder >= e.target.offsetTop
    const horizontalPositionOnRight = spaceOnRight >= e.target.offsetLeft

    const verticalPosition = verticalPositionUnder
      ? e.target.offsetTop
      : e.target.offsetTop - popHeight + e.target.offsetHeight
    const horizontalPosition = horizontalPositionOnRight
      ? e.target.offsetLeft
      : e.target.offsetLeft - popWidth + e.target.offsetWidth

    this.setState({
      activatedItemId: id,
      popOverPosition: verticalPositionUnder ? "under" : "above",
      popOver: {
        comment: currentItem.comment,
        description: currentItem.description,
        modifierClasses: "",
        isActive: true,
        topPx:    verticalPositionUnder
                  ? `${e.target.offsetTop + e.target.offsetHeight}px`
                  : `auto`,
        bottomPx: verticalPositionUnder
                  ? `auto`
                  : `${body.offsetHeight - e.target.offsetTop}px`,
        leftPx:   horizontalPositionOnRight
                  ? `${e.target.offsetLeft}px`
                  : `auto`,
        rightPx:  horizontalPositionOnRight
                  ? `auto`
                  : `${body.offsetWidth - e.target.offsetLeft - e.target.offsetWidth}px`,
      }
    })
  }

  render() {
    return (
      <div>
        <ToolBoxList
          items={this.state.items}
          activatedItem={this.state.activatedItemId}
          itemOnClick={this.toolClickHandler}
          popOverPosition={this.state.popOverPosition}
        />
        {this.state.popOver.isActive && (
          <ToolBoxPopOver
            top={this.state.popOver.topPx}
            bottom={this.state.popOver.bottomPx}
            left={this.state.popOver.leftPx}
            right={this.state.popOver.rightPx}
            modifierClasses={this.state.popOver.modifierClasses}
            description={this.state.popOver.description}
            comment={this.state.popOver.comment}
            onClick={this.deactivatePopOver}
          />
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/ToolBoxListContainer.jsx